import { useState, useEffect } from "react";

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_API_KEY;
// const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_API_KEY_TEST;

export function useUpsellLogic({ isOpen, manager, upsell }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const [loadingCard, setLoadingCard] = useState(false);
  const [isOpenPay, setIsOpenPay] = useState(false);
  const [renderedDescription, setRenderedDescription] = useState("");

  useEffect(() => {
    async function createStripePromise(stripeId) {
      if (!stripeId) return;
      const { loadStripe } = await import("@stripe/stripe-js");
      const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY, {
        stripeAccount: stripeId,
      });
      setStripePromise(stripe);
    }
    createStripePromise(manager?.stripeId);
  }, [manager?.stripeId]);

  // Description rendering
  useEffect(() => {
    if (isOpen && upsell?.description) {
      const urlRegex =
        /(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#/%?=~_|!:,.;]*[\-A-Z0-9+&@#/%=~_|])/gi;
      const youtubeRegex =
        /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
      const descriptionHTML = upsell.description.replace(urlRegex, (url) => {
        const match = url.match(youtubeRegex);
        if (match) {
          const videoId = match[4];
          return `<iframe width="100%" style="max-width: calc(100%); padding-top: 10px; padding-bottom: 10px;" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #ffb6b6;">${url}</a>`;
      });
      setRenderedDescription(descriptionHTML);
    }
  }, [isOpen, upsell?.description]);

  // Images
  useEffect(() => {
    async function loadImages() {
      if (isOpen && upsell?.images && upsell.images.length > 0) {
        const cloudfrontBaseUrl = "https://dl6ri8ttf37m3.cloudfront.net";
        const urls = upsell.images.map((imageKey) => {
          // If it's already a full URL, use it directly
          if (imageKey.startsWith("http")) {
            return imageKey;
          }
          
          // Construct optimized CloudFront URL
          const optimizedUrl = `${cloudfrontBaseUrl}/public/${encodeURIComponent(imageKey)}?width=600&format=webp`;
          return optimizedUrl;
        });
        setImageUrls(urls);
      } else {
        setImageUrls([]);
      }
    }
    loadImages();
  }, [isOpen, upsell?.images]);

  // Payment drawer controls
  const onOpenPay = () => setIsOpenPay(true);
  const onClosePay = () => setIsOpenPay(false);

  return {
    currentUser,
    setCurrentUser,
    stripePromise,
    imageUrls,
    loadingCard,
    setLoadingCard,
    isOpenPay,
    onOpenPay,
    onClosePay,
    renderedDescription,
  };
} 